import { render, staticRenderFns } from "./relationship-mapping.vue?vue&type=template&id=c49822a4&scoped=true&"
import script from "./relationship-mapping.vue?vue&type=script&lang=js&"
export * from "./relationship-mapping.vue?vue&type=script&lang=js&"
import style0 from "./relationship-mapping.vue?vue&type=style&index=0&id=c49822a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49822a4",
  null
  
)

export default component.exports